// config/modifyConfig.tsx
import React from "react";
import "./index.scss";
import { Checkbox, Box, Typography, Toggle, getColor } from "fds";
import { useTranslation } from "react-i18next";
import { ConfigDto, NotificationDTO } from "../../types/adminConfig";
interface MenuState {
  type: "view" | "edit";
  ecoCommonConfig: ConfigDto;
  setEcoCommonConfig?: (ecoCommonConfig: ConfigDto) => void;
}

const WorkgroupAlarmPage: React.FC<MenuState> = ({
  type,
  ecoCommonConfig,
  setEcoCommonConfig,
}) => {
  const { t } = useTranslation();
  const DEFAULT_SETTING = {
    usingWorkgroupInvitedAlert: false,
    usingFileAlert: true,
    fileAlert: ["fileshare", "memo", "revision"],
    usingReadRequestAlert: false,
    readRequestAlert: ["readRequest", "readRequestConfirm"],
  } as NotificationDTO;
  const handleChangeNotificationSetting = (key: string, value: any) => {
    if (!setEcoCommonConfig) return;
    setEcoCommonConfig({
      ...ecoCommonConfig,
      notificationPreferencePolicyDTO: {
        ...(ecoCommonConfig.notificationPreferencePolicyDTO || DEFAULT_SETTING),
        [key]: value,
      },
    });
  };
  return (
    <Box direction="column" width={"100%"}>
      <Box classes="adminConfig-info-box">
        <Box direction="column">
          <Typography type="subtitle2">
            {t("admin.config.alarm.workgroupTitle")}
          </Typography>
          <Typography
            classes="mg mt-4"
            type="body4_rg"
            exactColor={getColor("COLOR_TEXT_SECONDARY")}
          >
            {t("admin.config.alarm.workgroupInfo")}
          </Typography>
        </Box>
        <Toggle
          disabled={type === "view"}
          checked={
            ecoCommonConfig.notificationPreferencePolicyDTO
              ?.usingWorkgroupInvitedAlert
          }
          onChange={() =>
            handleChangeNotificationSetting(
              "usingWorkgroupInvitedAlert",
              !ecoCommonConfig.notificationPreferencePolicyDTO
                ?.usingWorkgroupInvitedAlert
            )
          }
        />
      </Box>
      <Box classes="adminConfig-info-box mg mt-16">
        <Box direction="column">
          <Typography type="subtitle2">
            {t("admin.config.alarm.fileTitle")}
          </Typography>
          <Typography
            classes="mg mt-4"
            type="body4_rg"
            exactColor={getColor("COLOR_TEXT_SECONDARY")}
          >
            {t("admin.config.alarm.fileInfo")}
          </Typography>
        </Box>
        <Toggle
          disabled={type === "view"}
          checked={
            ecoCommonConfig.notificationPreferencePolicyDTO?.usingFileAlert
          }
          onChange={() =>
            handleChangeNotificationSetting(
              "usingFileAlert",
              !ecoCommonConfig.notificationPreferencePolicyDTO?.usingFileAlert
            )
          }
        />
      </Box>
      {ecoCommonConfig.notificationPreferencePolicyDTO?.usingFileAlert && (
        <Box classes="adminConfig-info-box-gap12" direction="column">
          <Checkbox
            label={t("admin.config.alarm.uploadFile")}
            disable={type === "view"}
            check={ecoCommonConfig.notificationPreferencePolicyDTO?.fileAlert.includes(
              "fileshare"
            )}
            onClick={() =>
              handleChangeNotificationSetting(
                "fileAlert",
                ecoCommonConfig.notificationPreferencePolicyDTO?.fileAlert.includes(
                  "fileshare"
                )
                  ? ecoCommonConfig.notificationPreferencePolicyDTO?.fileAlert.filter(
                      (item) => item !== "fileshare"
                    )
                  : [
                      ...(ecoCommonConfig.notificationPreferencePolicyDTO
                        ?.fileAlert || []),
                      "fileshare",
                    ]
              )
            }
            justifyContent="flex-start"
          />
          <Checkbox
            label={t("admin.log.revision")}
            disable={type === "view"}
            check={ecoCommonConfig.notificationPreferencePolicyDTO?.fileAlert.includes(
              "revision"
            )}
            onClick={() =>
              handleChangeNotificationSetting(
                "fileAlert",
                ecoCommonConfig.notificationPreferencePolicyDTO?.fileAlert.includes(
                  "revision"
                )
                  ? ecoCommonConfig.notificationPreferencePolicyDTO?.fileAlert.filter(
                      (item) => item !== "revision"
                    )
                  : [
                      ...(ecoCommonConfig.notificationPreferencePolicyDTO
                        ?.fileAlert || []),
                      "revision",
                    ]
              )
            }
            justifyContent="flex-start"
          />
          <Checkbox
            label={t("admin.log.leaveComment")}
            disable={type === "view"}
            check={ecoCommonConfig.notificationPreferencePolicyDTO?.fileAlert.includes(
              "memo"
            )}
            onClick={() =>
              handleChangeNotificationSetting(
                "fileAlert",
                ecoCommonConfig.notificationPreferencePolicyDTO?.fileAlert.includes(
                  "memo"
                )
                  ? ecoCommonConfig.notificationPreferencePolicyDTO?.fileAlert.filter(
                      (item) => item !== "memo"
                    )
                  : [
                      ...(ecoCommonConfig.notificationPreferencePolicyDTO
                        ?.fileAlert || []),
                      "memo",
                    ]
              )
            }
            justifyContent="flex-start"
          />
        </Box>
      )}
      <Box classes="adminConfig-info-box mg mt-16">
        <Box direction="column">
          <Typography type="subtitle2">
            {t("admin.config.alarm.readReqestTitle")}
          </Typography>
          <Typography
            classes="mg mt-4"
            type="body4_rg"
            exactColor={getColor("COLOR_TEXT_SECONDARY")}
          >
            {t("admin.config.alarm.readReqestInfo")}
          </Typography>
        </Box>
        <Toggle
          disabled={type === "view"}
          checked={
            ecoCommonConfig.notificationPreferencePolicyDTO
              ?.usingReadRequestAlert
          }
          onChange={() =>
            handleChangeNotificationSetting(
              "usingReadRequestAlert",
              !ecoCommonConfig.notificationPreferencePolicyDTO
                ?.usingReadRequestAlert
            )
          }
        />
      </Box>
      {ecoCommonConfig.notificationPreferencePolicyDTO
        ?.usingReadRequestAlert && (
        <Box classes="adminConfig-info-box-gap12" direction="column">
          <Checkbox
            label={t("admin.config.alarm.request")}
            disable={type === "view"}
            check={ecoCommonConfig.notificationPreferencePolicyDTO?.readRequestAlert.includes(
              "readRequest"
            )}
            onClick={() =>
              handleChangeNotificationSetting(
                "readRequestAlert",
                ecoCommonConfig.notificationPreferencePolicyDTO?.readRequestAlert.includes(
                  "readRequest"
                )
                  ? ecoCommonConfig.notificationPreferencePolicyDTO?.readRequestAlert.filter(
                      (item) => item !== "readRequest"
                    )
                  : [
                      ...(ecoCommonConfig.notificationPreferencePolicyDTO
                        ?.readRequestAlert || []),
                      "readRequest",
                    ]
              )
            }
            justifyContent="flex-start"
          />
          <Checkbox
            label={t("admin.config.alarm.readRequestConfirm")}
            disable={type === "view"}
            check={ecoCommonConfig.notificationPreferencePolicyDTO?.readRequestAlert.includes(
              "readRequestConfirm"
            )}
            onClick={() =>
              handleChangeNotificationSetting(
                "readRequestAlert",
                ecoCommonConfig.notificationPreferencePolicyDTO?.readRequestAlert.includes(
                  "readRequestConfirm"
                )
                  ? ecoCommonConfig.notificationPreferencePolicyDTO?.readRequestAlert.filter(
                      (item) => item !== "readRequestConfirm"
                    )
                  : [
                      ...(ecoCommonConfig.notificationPreferencePolicyDTO
                        ?.readRequestAlert || []),
                      "readRequestConfirm",
                    ]
              )
            }
            justifyContent="flex-start"
          />
        </Box>
      )}
    </Box>
  );
};

export default WorkgroupAlarmPage;
